import { ApiResponse } from '../types/http';
import { CustomObject } from '../types/data';

class DataService {
  isSuccess = (payload: ApiResponse) => {
    return !!payload.success;
  };

  parseData = (payload: ApiResponse) => {
    return payload.response;
  };

  parseErrors = (payload: ApiResponse) => {
    // const fields = DataService.parseFields(data);
    const message = this.parseMessage(payload.error || {});

    return {
      // fields,
      message,
    };
  };

  parseFields = (data: CustomObject) => {
    return data.fields;
  };

  parseMessage = (data: CustomObject) => {
    if (data?.description) {
      return data.description;
    }

    return 'Server Error';
  };
}

export default new DataService();
